import restClient from 'config/httpClient';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { LANGUAGE } from 'constants/Parameters';
import { PATH, PATH_NAME } from 'constants/Routes';

import { redirectToBO } from 'modules/entity/subEntities/customize/utils';

import * as intlActions from 'modules/app/intl/actions';
import * as actions from 'modules/entity/subEntities/customize/actions';
import { createNotification } from 'modules/notifications/actions';

import { fetchEntitySuccess } from 'modules/entity/actions';
import { getEntity } from 'modules/entity/selectors';
import { getUiTranslations } from './selectors';

export function* afterFetchCustomize() {
  if (PATH[PATH_NAME.CUSTOMIZE].match(window.location.pathname)) {
    const template = yield select(getEntity);
    yield put(actions.setSelectedTemplate(template.id));
    yield put(intlActions.fetchTranslations(template.translationsUrl, LANGUAGE));
  }
}

export function* postTemplate({ payload }) {
  const { request, template } = payload;
  const uiTranslations = yield select(getUiTranslations);

  try {
    yield call(restClient.request, request);
    yield put(actions.sendCustomizeSuccess());
    yield put(
      createNotification({
        type: 'success',
        message: uiTranslations['web.custom-template.save.success'] ?? 'The template has been saved successfully.',
      })
    );
    yield delay(1000);
    yield call(redirectToBO, template?.dealerId);
  } catch (error) {
    yield put(actions.sendCustomizeFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: uiTranslations['web.custom-template.save.failure'] ?? 'The template was not saved.',
      })
    );
  }
}

export default function* customizeSagas() {
  yield takeLatest(actions.sendCustomize, postTemplate);
  yield takeLatest(fetchEntitySuccess, afterFetchCustomize);
}
